import { TicketDetailsPage } from './TicketDetails'
import { TicketsViewType } from './TicketsViewType'

const TicketBrokerageDetails = (): JSX.Element => {
  return <TicketDetailsPage viewType={TicketsViewType.Brokerage} />
}

export default TicketBrokerageDetails
